import React, { useState } from 'react'
import MailboxContent1 from '../Mailbox/mailboxcontent1'
import MailboxContent2 from '../Mailbox/mailboxcontent2'
import ReportSubmited from '../reportsubmited'; // Import the ReportSubmited component

function MailboxMain() {
    const [content, setContent] = useState(1); // State to track which content to display, starting from 1 (for content1)
    const [showStepCount, setShowStepCount] = useState(true); // State to toggle the step counter visibility

    const _OnNext = () => {
        setContent((prevContent) => {
            const nextContent = prevContent + 1;
            if (nextContent === contentArray.length) {
                setShowStepCount(false); // Hide step count when navigating to ReportSubmited
            }
            return Math.min(nextContent, contentArray.length); // Ensure we don't exceed the number of steps
        });
    };

    const handleStepClick = (step) => {
        setContent(step);
        if (step === contentArray.length) {
            setShowStepCount(false);
        } else {
            setShowStepCount(true);
        }
    };

    const contentArray = [
        <MailboxContent1 onNext={_OnNext} />,
        <MailboxContent2 onNext={_OnNext} />,
        <ReportSubmited />,
    ];
    return (
        <div className="report-content mailboxcontent">
            {/* Conditional rendering of the header */}
            {showStepCount && (
                <div className="report-header">
                    <div className="title-stepcount">
                        <h1>Report Form</h1>
                        <p>
                            Step <span>{content}</span> of {contentArray.length - 1}
                        </p>
                    </div>
                    {/* <div className="stepindicator">

                        {contentArray.slice(0, contentArray.length - 1).map((_, index) => (
                            <button
                                key={index}
                                className={content >= index + 1 ? 'active' : ''}
                                onClick={() => handleStepClick(index + 1)}
                            ></button>
                        ))}
                    </div> */}
                </div>
            )}

            <div className="report-body">
                {contentArray[content - 1]}
            </div>
        </div>
    );
}

export default MailboxMain